export default __webpack_public_path__ + "static/media/img-0638-north-macedonia-full-face.60904422.png";